/**
 * @generated SignedSource<<4421eda6dff8072f6baaee9521b57f92>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type endRentalPageOpenOwnerMutation$variables = {
  reservationId: string;
};
export type endRentalPageOpenOwnerMutation$data = {
  readonly lockReservationUnlock: {
    readonly id: string;
  };
};
export type endRentalPageOpenOwnerMutation = {
  response: endRentalPageOpenOwnerMutation$data;
  variables: endRentalPageOpenOwnerMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "reservationId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "lockReservationId",
            "variableName": "reservationId"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "UnlockRequest",
    "kind": "LinkedField",
    "name": "lockReservationUnlock",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "endRentalPageOpenOwnerMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "endRentalPageOpenOwnerMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "a78c8e2f72cdbb4cf6c2ac6e36ebc883",
    "id": null,
    "metadata": {},
    "name": "endRentalPageOpenOwnerMutation",
    "operationKind": "mutation",
    "text": "mutation endRentalPageOpenOwnerMutation(\n  $reservationId: UUID!\n) {\n  lockReservationUnlock(input: {lockReservationId: $reservationId}) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "48e720b780b15651dcd9452598fae6d7";

export default node;
